// extracted by mini-css-extract-plugin
export default {"container":"gJ-z","disabled":"hJ-z","bgBlack":"iJ-z","content":"jJ-z","countdown":"kJ-z","topCaption":"lJ-z","topHeading":"mJ-z","heading":"nJ-z","copy":"oJ-z"};